/*
 * Focused Shift Kit launcher page — mounted at `/shift-kit`.
 *
 * Installed PWA start_url points here. Renders the same
 * `<ShiftKitSection />` used inside the Pro Carer Hub, wrapped in a
 * minimal JCC / Shift Kit header + Back-to-hub link. No standard site
 * navbar/footer, no other Pro Hub sections, no pricing, no teaser.
 *
 * Access is enforced upstream by `<HandoverGate requiredEntitlement="pro_carer">`
 * in App.js — logged-out users get the sign-in card, non-Pro users get
 * the "not included in your access" panel.
 */
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ShiftKitSection from "../components/workspace/ShiftKitSection";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_care-toolkit-pro/artifacts/xtaliuak_Just%20Care%20-%201.png";

export default function ShiftKitFocused() {
  return (
    <div data-testid="page-shift-kit-focused" className="min-h-screen bg-[#f7f7f3]">
      <header
        className="sticky top-0 z-30 border-b border-slate-200 bg-white/95 backdrop-blur"
        data-testid="shift-kit-focused-header"
      >
        <div className="container-jcc flex items-center justify-between py-3">
          <div className="flex items-center gap-3 min-w-0">
            <img
              src={LOGO_URL}
              alt="Just Care Community"
              className="h-8 w-auto shrink-0"
            />
            <div className="min-w-0">
              <div className="font-display text-sm font-semibold text-ink leading-tight truncate">
                Shift Kit
              </div>
              <div className="text-[11px] text-ink-muted leading-tight truncate">
                Pro Carer Office
              </div>
            </div>
          </div>
          <Link
            to="/workspace/pro-carer-circle"
            data-testid="shift-kit-focused-back"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-teal hover:text-teal-600 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" strokeWidth={2} />
            <span className="hidden sm:inline">Back to Pro Carer Hub</span>
            <span className="sm:hidden">Back</span>
          </Link>
        </div>
      </header>

      <main className="container-jcc py-8 md:py-10">
        <ShiftKitSection />
      </main>
    </div>
  );
}
